import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { DatetimePickerComponent } from './datetime-picker.component';

@NgModule({
    imports: [CommonModule, IonicModule],
    declarations: [DatetimePickerComponent],
    exports: [DatetimePickerComponent],
    providers: []
})
export class DateTimePickerModule {}
